export const en = {
    'banner-required-href-turbo-vcard-organization':
        'Enter the link to your site, create a Turbo page, fill out your vCard or link a company from the Yandex Business Directory',
    'organization-not-found': "Couldn't find the selected organization in Yandex Business Directory"
};
